import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SanctionsRescreenService } from '../tokens/sanctions-rescreen.token';
import { SanctionsRescreenRequest, SanctionsRescreenResult } from '../models/kyc.model';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of {@link SanctionsRescreenService} — EM-1349.
 *
 * Calls:
 *   POST /services/embedded/api/onboarding-application/{applicationId}/sanctions-screening/rescreen
 *
 * Authenticated via the portal's `authInterceptor` (the signed-in KYC officer's Keycloak bearer
 * token). Rules 07 + 10 — no mock fallback, no in-memory state, no `Mock*` sibling class.
 */
@Injectable()
export class SanctionsRescreenRestService implements SanctionsRescreenService {
  private readonly http = inject(HttpClient);

  rescreen(
    applicationId: number,
    request: SanctionsRescreenRequest,
  ): Observable<SanctionsRescreenResult> {
    return this.http.post<SanctionsRescreenResult>(
      `${API_PATHS.ONBOARDING_APPLICATION}/${applicationId}/sanctions-screening/rescreen`,
      request,
    );
  }
}
